<template>
  <el-dialog
    title="调整计提金额"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="原金额">
        <el-input-number
          v-model="form.originalAmount"
          :precision="2"
          :controls="false"
          disabled
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="调整后金额" prop="updateAmount">
        <el-input-number
          v-model="form.updateAmount"
          :precision="2"
          :min="0"
          :max="999999999.99"
          style="width: 100%"
          placeholder="请输入调整后金额"
        />
      </el-form-item>

      <el-form-item label="调整原因" prop="adjustReason">
        <el-input
          v-model="form.adjustReason"
          type="textarea"
          :rows="4"
          placeholder="请输入调整原因"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="dialogVisible = false">{{ $t('common.btn.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.btn.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { adjustAmount } from '@/api/provision/provisionData'

export default {
  name: 'AdjustDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        originalAmount: 0,
        updateAmount: null,
        adjustReason: ''
      },
      rules: {
        updateAmount: [
          { required: true, message: '调整后金额未输入，无法提交', trigger: 'blur' }
        ],
        adjustReason: [
          { required: true, message: '调整原因未输入，无法提交', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.selectedRows.length > 0) {
        // 初始化表单数据
        this.form.originalAmount = this.selectedRows[0].provisionAmount || 0
        this.form.updateAmount = this.selectedRows[0].updateAmount || null
        this.form.adjustReason = this.selectedRows[0].adjustReason || ''
      }
    }
  },
  methods: {
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()

        const res = await adjustAmount({
          uuids: this.selectedRows.map(row => row.uuid),
          updateAmount: this.form.updateAmount,
          adjustReason: this.form.adjustReason
        })

        if (res.ok) {
          this.dialogVisible = false
          this.$emit('success')
        }
      } catch (error) {
        console.error(error)
      }
    },

    handleClose() {
      this.$refs.formRef.resetFields()
      this.form = {
        originalAmount: 0,
        updateAmount: null,
        adjustReason: ''
      }
    }
  }
}
</script>
